import { render } from "./UpgradeBandages.vue?vue&type=template&id=2998f83c"
import script from "./UpgradeBandages.vue?vue&type=script&lang=js"
export * from "./UpgradeBandages.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/hero/windowOverlay/UpgradeBandages.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2998f83c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2998f83c', __exports__)) {
    api.reload('2998f83c', __exports__)
  }
  
  module.hot.accept("./UpgradeBandages.vue?vue&type=template&id=2998f83c", () => {
    api.rerender('2998f83c', render)
  })

}


export default __exports__